<div #tableWrapper class="w-100-p" *ngIf="dataSource">
    <mat-table
        [class.hidden]="!(filteredUser$ | async).length || isLoading"
        #table
        [dataSource]="dataSource"
        matSort
        matSortActive="{{ sortBy }}"
        matSortDirection="{{ sortOrder }}"
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)"
    >
        <!-- Checkbox Column -->
        <ng-container matColumnDef="checkbox">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (mouseenter)="onMouseEnter($event)"
                    (mouseleave)="onMouseLeave($event)"
                    (change)="$event ? toggle.emit(isAllSelected) : null"
                    [checked]="selectedUserIds.length && isAllSelected"
                    [indeterminate]="selectedUserIds.length && !isAllSelected"
                >
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <mat-checkbox [(ngModel)]="checkboxes[user.id]" (ngModelChange)="select.emit(user)" (click)="$event.stopPropagation()"> </mat-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell class="user-details-card-container" *matCellDef="let user">
                <div class="relative" #avatarCell>
                    <img class="avatar pointer" *ngIf="user.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                    <ng-template #initials>
                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                    </ng-template>
                    <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                </div>
                <app-user-details-card
                    [class.hidden]="isUserDetailsCardHidden"
                    [user]="user"
                    [target]="avatarCell"
                    openedFrom="contact_card_allusers"
                    (goToAction)="goToUserProfile(user.id)"
                ></app-user-details-card>
            </mat-cell>
        </ng-container>

        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header class="active-user-list-mat-header"
                >{{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}
            </mat-header-cell>
            <mat-cell class="user-details-card-container" *matCellDef="let user">
                <div
                    #firstNameRow
                    class="text-truncate font-medium pointer"
                    [matTooltip]="user.firstName"
                    [matTooltipDisabled]="firstNameRow.scrollWidth <= firstNameRow.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ user.firstName }}
                </div>
            </mat-cell>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header class="active-user-list-mat-header"
                >{{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
            </mat-header-cell>
            <mat-cell class="user-details-card-container" *matCellDef="let user">
                <div
                    #lastNameRow
                    class="text-truncate font-medium pointer"
                    [matTooltip]="user.lastName"
                    [matTooltipDisabled]="lastNameRow.scrollWidth <= lastNameRow.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ user.lastName }}
                </div>
            </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-sm="true" class="active-user-list-mat-header">
                {{ 'GENERAL.PROPERTY.EMAIL' | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-sm="true">
                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    class="bg-gray-100 hover:bg-gray-200 py-8 pr-16 pl-8 rounded-full text-truncate"
                    (click)="$event.stopPropagation()"
                    (mouseenter)="onMouseEnter($event)"
                    (mouseleave)="onMouseLeave($event)"
                >
                    <mat-icon svgIcon="send_message" class="mr-8 icon-18"></mat-icon>
                    <a
                        #emailEl
                        class="text-truncate"
                        [href]="'mailto:' + user.email"
                        target="_top"
                        [matTooltip]="user.email"
                        [matTooltipDisabled]="emailEl.scrollWidth <= emailEl.clientWidth"
                        [matTooltipShowDelay]="500"
                        >{{ user.email }}</a
                    >
                </div>
            </mat-cell>
        </ng-container>

        <!-- Language Column -->
        <ng-container matColumnDef="language">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-sm="true" class="active-user-list-mat-header"
                >{{ 'GENERAL.PROPERTY.LANGUAGE' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-sm="true">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="(user.language | language).translate | translate"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ (user.language | language).translate | translate }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Reset password last sent -->
        <ng-container matColumnDef="resetPasswordLastSent">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-sm="true" class="active-user-list-mat-header"
                >{{ 'GENERAL.PROPERTY.RESET_PASSWORD_LAST_SEND' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-sm="true">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="user.resetPasswordLastSent ? user.resetPasswordLastSent.fromNow(false) : ('GENERAL.PROPERTY.RESET_PASSWORD_NEVER' | translate)"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ user.resetPasswordLastSent ? user.resetPasswordLastSent.fromNow(false) : ('GENERAL.PROPERTY.RESET_PASSWORD_NEVER' | translate) }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Last login Column -->
        <ng-container matColumnDef="lastLogin">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-sm="true" class="active-user-list-mat-header">
                {{ 'GENERAL.PROPERTY.LAST_LOGIN' | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-sm="true">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="user.analytics.lastLogin ? user.analytics.lastLogin.fromNow(false) : ('GENERAL.LABEL.NEVER' | translate)"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ user.analytics.lastLogin ? user.analytics.lastLogin.fromNow(false) : ('GENERAL.LABEL.NEVER' | translate) }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Login count Column -->
        <ng-container matColumnDef="loginCount">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-sm="true" class="active-user-list-mat-header">
                {{ 'GENERAL.PROPERTY.LOGIN_COUNT' | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-sm="true">
                <p #el class="text-truncate pr-4" [matTooltip]="user.analytics.loginCount || 0" [matTooltipDisabled]="el.scrollWidth <= el.clientWidth" [matTooltipShowDelay]="500">
                    {{ user.analytics.loginCount || 0 }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-xs="true" class="active-user-list-mat-header">
                {{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-xs="true">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="user.status | getStatus: userStatuses:'translationLabel' | translate"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ user.status | getStatus: userStatuses:'translationLabel' | translate }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Created At Column -->
        <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-xs="true" class="active-user-list-mat-header">
                {{ 'GENERAL.PROPERTY.CREATED_ON' | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-xs="true">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="user.createdAt ? (user.createdAt | date: 'short') : '-'"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ user.createdAt ? (user.createdAt | date: 'short') : '-' }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Updated At Column -->
        <ng-container matColumnDef="updatedAt">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-xs="true" class="active-user-list-mat-header">
                {{ 'GENERAL.PROPERTY.LAST_MODIFIED' | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-xs="true">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="user.updatedAt ? (user.updatedAt | date: 'short') : '-'"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ user.updatedAt ? (user.updatedAt | date: 'short') : '-' }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- User Role -->
        <ng-container matColumnDef="userRole">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview fxHide="true" fxShow.gt-xs="true" class="active-user-list-mat-header">
                {{ 'GENERAL.LABEL.USER_ROLE' | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-xs="true">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="(user.permissions.includes('tenant_management') ? 'GENERAL.ADMINISTRATOR' : 'USER.SINGULAR') | translate"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ (user.permissions.includes('tenant_management') ? 'GENERAL.ADMINISTRATOR' : 'USER.SINGULAR') | translate }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Extended Attributes Columns -->
        <ng-container *ngFor="let attribute of extendedAttributes" [matColumnDef]="attribute.name">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview mat-sort-header fxHide="true" fxShow.gt-xs="true" class="active-user-list-mat-header">
                {{ attribute.translationKey | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-xs="true">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="attribute | getUserExtendedAttributeValue: user.attributes"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ attribute | getUserExtendedAttributeValue: user.attributes }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Social Networks -->
        <ng-container matColumnDef="socialNetworks">
            <mat-header-cell *matHeaderCellDef cdkDrag cdkDragPreview fxHide="true" fxShow.gt-xs="true" class="active-user-list-mat-header">
                {{ 'SOCIAL_NETWORK.PLURAL' | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let user" fxHide="true" fxShow.gt-xs="true">
                <div fxLayout="row wrap" fxLayoutAlign="start center" *ngIf="user.socialNetworks?.length">
                    <a class="text-truncate" *ngFor="let network of user.socialNetworks" href="{{ network.value }}" target="_blank">
                        <img class="social-icon" [alt]="network.type" [src]="network.imageUrl" />
                    </a>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef>
                <div fxFlex="row" fxLayoutAlign="end center">
                    <mat-form-field class="active-user-columns-trigger">
                        <mat-icon matPrefix svgIcon="table_columns_dropdown"></mat-icon>
                        <mat-select
                            #columnsSelect
                            [formControl]="tableColumnsDropdown"
                            multiple
                            panelClass="active-user-columns-panel"
                            (openedChange)="onColumnsDropdownOpenedChange($event)"
                        >
                            <div class="columns-options-scroll">
                                <mat-option *ngFor="let column of possibleTableColumns" [value]="column.id" [class.hidden-option]="!column.translation">
                                    {{ column.translation | translate }}
                                </mat-option>
                            </div>
                            <footer class="apply-columns-footer" (click)="$event.stopPropagation()">
                                <button mat-flat-button color="primary" class="w-100-p" (click)="applyColumns()">
                                    {{ 'GENERAL.BUTTON.APPLY' | translate }}
                                </button>
                            </footer>
                        </mat-select>
                    </mat-form-field>
                </div>
            </mat-header-cell>

            <mat-cell *matCellDef="let user; let i = index">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <div
                        fxFlex="row"
                        fxLayoutAlign="end center"
                        class="opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                        [class.group-hover:!opacity-0]="isActionBoxHovered"
                        *ngIf="!isCommunityPage"
                    >
                        <p class="text-sm font-normal text-gray-500 mr-8">
                            {{ 'GENERAL.LABEL.SEE_PROFILE' | translate }}
                        </p>

                        <mat-icon class="icon-18 opacity-0 transition-opacity duration-300 group-hover:opacity-100" [class.group-hover:!opacity-0]="isActionBoxHovered">
                            keyboard_arrow_right
                        </mat-icon>
                    </div>

                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="moreMenu"
                        aria-label="More"
                        *ngIf="!(selectedUserIds.length > 1) && !isCommunityPage && hasTenantAdminOrUsersWritePermission"
                        (click)="$event.stopPropagation()"
                        (mouseenter)="onMouseEnter($event)"
                        (mouseleave)="onMouseLeave($event)"
                    >
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before" [yPosition]="i > ((filteredUser$ | async) || []).length - 2 ? 'above' : 'below'">
                        <button
                            mat-menu-item
                            aria-label="chat"
                            (click)="startConversation(user)"
                            *ngIf="!fuseConfig.layout.sidepanel.hidden && user.id !== profile.id"
                            [disabled]="user.status !== 'active'"
                        >
                            <mat-icon class="mr-8">message</mat-icon>
                            <span>{{ 'GENERAL.PROPERTY.START_CONVERSATION' | translate }}</span>
                        </button>
                        <button mat-menu-item aria-label="edit" (click)="edit.emit(user)">
                            <mat-icon class="mr-8">edit</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.EDIT' | translate }}</span>
                        </button>

                        <button mat-menu-item aria-label="reset" (click)="changeEmailAddress(user)">
                            <mat-icon class="mr-8" svgIcon="edit_message"></mat-icon>
                            <span>{{ 'GENERAL.BUTTON.CHANGE_EMAIL_ADDRESS' | translate }}</span>
                        </button>

                        <button *ngIf="!isSSOFeatureEnabled" mat-menu-item aria-label="reset" (click)="resetPassword(user)">
                            <mat-icon class="mr-8">loop</mat-icon>
                            <span>{{ 'USER.BUTTON.RESET_PASSWORDS' | translate: { total: 1 } }}</span>
                        </button>

                        <button mat-menu-item aria-label="assign" (click)="getResetPasswordUrl(user)" [disabled]="user.status !== 'active'">
                            <mat-icon class="mr-8">file_copy</mat-icon>
                            <span>{{ 'USER.BUTTON.COPY_PASSWORD_RESET_LINK' | translate }}</span>
                        </button>

                        <button mat-menu-item aria-label="assign" (click)="assignUserToAudience(user)" *ngIf="isEngageFeatureEnabled">
                            <mat-icon class="mr-8" svgIcon="assign_user_to_audience"></mat-icon>
                            <span>{{ 'USER.BUTTON.ASSIGN_TO_AUDIENCE' | translate }}</span>
                        </button>

                        <button mat-menu-item aria-label="assign" (click)="assignUserToExperience(user)" *ngIf="isEngageFeatureEnabled">
                            <mat-icon class="mr-8" svgIcon="assign_user_to_experience"></mat-icon>
                            <span>{{ 'USER.BUTTON.ASSIGN_TO_EXPERIENCE' | translate }}</span>
                        </button>

                        <button
                            mat-menu-item
                            aria-label="passwordless access"
                            (click)="openPasswordlessAccessDialog(user)"
                            *ngIf="isPasswordlessLoginFeatureEnabled"
                            [disabled]="user.status !== 'active'"
                        >
                            <mat-icon class="mr-8" svgIcon="qr_code"></mat-icon>
                            <span>{{ 'USER.BUTTON.CREATE_PASSWORDLESS_ACCESS' | translate }}</span>
                        </button>

                        <button mat-menu-item aria-label="assign" (click)="openAssignUserToTeamDialog(user)" *ngIf="isTeamsFeatureEnabled">
                            <mat-icon class="mr-8" svgIcon="team"></mat-icon>
                            <span>{{ 'USER.BUTTON.ASSIGN_TO_TEAM' | translate }}</span>
                        </button>

                        <button mat-menu-item aria-label="deactivate" (click)="deactivateUser(user)" *ngIf="user.status === 'active'">
                            <mat-icon class="mr-8">remove_circle</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.DEACTIVATE' | translate }}</span>
                        </button>

                        <button mat-menu-item aria-label="activate" (click)="activateUser(user)" *ngIf="user.status !== 'active'">
                            <mat-icon class="mr-8">add_circle</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.ACTIVATE' | translate }}</span>
                        </button>

                        <button mat-menu-item aria-label="delete" (click)="deleteUser(user)" *ngIf="user.status !== 'active'">
                            <mat-icon class="mr-8">delete</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.DELETE' | translate }}</span>
                        </button>
                    </mat-menu>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let user; columns: displayedColumns" class="relative group pointer hover:bg-gray-50" (click)="goToUserProfile(user.id)"> </mat-row>
    </mat-table>

    <div class="white" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
        <div class="shimmer-container min-w-full p-0">
            <div class="shimmer p-12">
                <div class="shimmer-card !max-w-full table h-480 animate"></div>
            </div>
        </div>
    </div>

    <div fxLayout="column" fxLayoutAlign="center center" class="no-results-wrapper pt-24" *ngIf="!(filteredUser$ | async).length && !isLoading">
        <div class="no-results-container mb-32" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="participant-view-illustration" svgIcon="search_no_results"></mat-icon>
            <h2>{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
            <span>
                {{ 'GENERAL.LABEL.TRY_SEARCH_SOMETHING_ELSE' | translate }}
            </span>
        </div>
    </div>

    <mat-paginator
        [persistPageSize]="pageSizePreferenceKey"
        [class.hidden]="!(filteredUser$ | async).length || isLoading"
        [length]="totalCount$ | async"
        [pageSize]="50"
        [pageSizeOptions]="[10, 25, 50]"
    ></mat-paginator>
</div>
